(function($) {
  $.fn.vacancy = function(options) {
    var defaults = {
      applyBtn: '.vacancy-hero__apply_btn',
      // saveDependantBtn: '.vacancy-form__save-dependant-button',
      saveAcademicQualificationBtn: '.vacancy-form__save-academic-qualification-button',
      saveTrainingsBtn: '.vacancy-form__save-trainings-button',
      saveAssociationsBtn: '.vacancy-form__save-associations-button',
      saveExperienceBtn: '.vacancy-form__save-experience-button',
      saveReferencesBtn: '.vacancy-form__save-references-button',
      form: '.vacancy-hero__form',
      container: '.vacancy-form__container',
      regionSelect: '.hero-image__select',
      regionSelectResultsContainer: '.current-vacancies__results'
    };

    var addRowConfig = {
      // dependants: {
      //   table_selector: '.vacancy-form__dependant-table table',
      //   fields: {
      //     first_name: '#forms_application_form_dependant_first_name',
      //     middle_name: '#forms_application_form_dependant_middle_name',
      //     last_name: '#forms_application_form_dependant_last_name',
      //     gender: 'input[name="forms_application_form[dependant_gender]"]',
      //     date_of_birth: '#forms_application_form_dependant_date_of_birth',
      //     relationship: '#forms_application_form_dependant_relationship'
      //   }
      // },
      academicQualifications: {
        table_selector: '.vacancy-form__academic-qualification-table table',
        fields: {
          institution: '#forms_application_form_academic_institution',
          from: '#forms_application_form_academic_from',
          until: '#forms_application_form_academic_until',
          certificate: '#forms_application_form_academic_certificate',
          grade: '#forms_application_form_academic_grade'
        }
      },
      trainings: {
        table_selector: '.vacancy-form__trainings-table table',
        fields: {
          institution: '#forms_application_form_training_institution',
          course: '#forms_application_form_training_course',
          completion: '#forms_application_form_training_completion',
          certificate: '#forms_application_form_training_certificate'
        }
      },
      associations: {
        table_selector: '.vacancy-form__associations-table table',
        fields: {
          name: '#forms_application_form_association_name',
          country: '#forms_application_form_association_country'
        }
      },
      experience: {
        table_selector: '.vacancy-form__experience-table table',
        fields: {
          industry: '#forms_application_form_experience_industry',
          employer: '#forms_application_form_experience_employer',
          from: '#forms_application_form_experience_from',
          until: '#forms_application_form_experience_until',
          position: '#forms_application_form_experience_position',
          current_salary: '#forms_application_form_experience_current_salary',
          currency: '#forms_application_form_experience_currency',
          email: '#forms_application_form_experience_email',
          telephone: '#forms_application_form_experience_telephone',
          job_description: '#forms_application_form_experience_job_description'
        }
      },
      references: {
        table_selector: '.vacancy-form__references-table table',
        fields: {
          name: '#forms_application_form_reference_name',
          business: '#forms_application_form_reference_business',
          email: '#forms_application_form_reference_email',
          contact: '#forms_application_form_reference_contact_information'
        }
      }
    };

    // var dependants = [];
    var academic_qualifications = [];
    var trainings = [];
    var associations = [];
    var experience = [];
    var references = [];

    var settings = $.extend( {}, defaults, options );

    var apply_form = $('.apply-form');

    var hashVal = window.location.hash.split("#")[1];
    if(hashVal == 'application_form') {
      initialize_apply_form();
    }

    function initialize_apply_form() {
      $(settings.container).show();
      selectize_all_selects();
      FormDisclaimer.disclaimerHandler();

      $('.apply-form').find('.panel').on('shown.bs.collapse', function() {
        selectize_all_selects();
        var inputs = $(this).find("input[data-picker='datepicker']").not('.datepicker-active');
        $(inputs).datepicker({
          format: 'dd/mm/yyyy'
        })
        $(inputs).addClass('datepicker-active');
      });

      // add_file_upload_handler("#apply-form__upload-photograph-btn", "#apply-form__upload-photographs");
      add_file_upload_handler("#apply-form__upload-resume-btn", "#apply-form__upload-resumes");
      add_file_upload_handler("#apply-form__upload-cover-letter-btn", "#apply-form__upload-cover-letters");

      // dependants = apply_form.data('storage-data-dependants');
      academic_qualifications = apply_form.data('storage-data-academic-qualifications');
      trainings = apply_form.data('storage-data-trainings');
      associations = apply_form.data('storage-data-associations');
      experience = apply_form.data('storage-data-experience');
      references = apply_form.data('storage-data-references');

      // addHandlers(dependants, addRowConfig.dependants, $(settings.saveDependantBtn));
      addHandlers(academic_qualifications, addRowConfig.academicQualifications, $(settings.saveAcademicQualificationBtn));
      addHandlers(trainings, addRowConfig.trainings, $(settings.saveTrainingsBtn));
      addHandlers(associations, addRowConfig.associations, $(settings.saveAssociationsBtn));
      addHandlers(experience, addRowConfig.experience, $(settings.saveExperienceBtn));
      addHandlers(references, addRowConfig.references, $(settings.saveReferencesBtn));

    };

    function add_file_upload_handler(button_selector, target_selector) {
      $(button_selector).on('change', function() {
        $(target_selector).html('');
        for (index = 0; index < this.files.length; ++index) {
          $(target_selector).append('<div class="upload-file-entry">' + this.files[index].name + '<a href="#"><span class="fa fa-remove remove-upload-file"></span></a></div>');
        }
        removeFileHandler(this, target_selector);
      });
    };

    function addHandlers(storage, config, button) {
      $.each(storage, function(index, local_object) {
        local_object.id = index
        if (storage.length > 0) {
          $(config.table_selector).show();
        }
        var remove_selector = config.table_selector + ' tr[data-object-id=' + index + '] .remove-object';
        var edit_selector = config.table_selector + ' tr[data-object-id=' + index + '] .edit-object';
        addRemoveHandler(remove_selector, index, storage, config, button);
        addEditHandler(edit_selector, index, storage, button, config);
      });
    };

    function addRemoveHandler(element_selector, id, object_storage, config, button) {
      $(element_selector).on('click', function(event) {
        $(this).parents('tr').remove();
        object_storage.splice(find_storage_element_by_id(id, object_storage), 1);

        if (object_storage.length == 0) {
          $(config.table_selector).hide();
        }
        if (button.data('object-id') == id) {
          button.removeData('object-id');
        }
      });
    };

    function addEditHandler(element_selector, id, object_storage, button, config) {
      var obj = object_storage[find_storage_element_by_id(id, object_storage)];
      var fields = {}
      $.each(config.fields, function(index, value) {
        fields[index] = $(value);
      });

      $(element_selector).on('click', function(event) {
        button.data('object-id', obj.id);
        // Load objects values in input fields
        $.each(fields, function(index, value) {
          if (value.hasClass('radio_buttons')) {
            element = $(value.selector + "[value=" + obj[index] + "]");
            $('#' + element.attr('id')).prop('checked', true);
          } else {
            value.val(obj[index]);
          }
          if (value.hasClass('selectized')) {
            $(value).selectize()[0].selectize.setValue(obj[index]);
          }
        });
      });
    }

    function find_storage_element_by_id(id, array) {
      for (var i=0; i < array.length; i++) {
        if (array[i].id === id) {
          return i;
        }
      }
    }

    function saveRow(config, button, object_storage) {
      var $table = $(config.table_selector);
      var fields = {};

      $.each(config.fields, function(index, value) {
        fields[index] = $(value);
      });

      var local_object = null;

      if (button.data('object-id') !== undefined) {
        local_object = object_storage[find_storage_element_by_id(button.data('object-id'), object_storage)];
      } else {
        local_object = {};
      }

      var hasInvalidFields = false;
      $.each(fields, function(index, value) {
        value.parents('.form-group').find('.help-block').remove();
        value.parents('.form-group').removeClass('has-error');

        if (value.data('validate-presence')) {
          if (value.val() == null || value.val().trim() == "") {
            value.parents('.form-group').append('<span class="help-block">' + value.data('validate-presence') + '</span>');
            value.parents('.form-group').addClass('has-error');
            hasInvalidFields = true
            return;
          }
        }

        if (value.data('validate-date')) {
          var re = new RegExp("^([0-9]{2}/[0-9]{2}/[0-9]{4})$");

          if (re.test(value.val())) {
            splitted_date = value.val().split("/")
            date = Date.parse(splitted_date[1] + "/" + splitted_date[0] + "/" + splitted_date[2])
            if (isNaN(date)) {
              hasInvalidFields = true
              value.parents('.form-group').append('<span class="help-block">' + value.data('validate-date') + '</span>');
              value.parents('.form-group').addClass('has-error');
              return;
            }
          } else {
            hasInvalidFields = true
            value.parents('.form-group').append('<span class="help-block">' + value.data('validate-date') + '</span>');
            value.parents('.form-group').addClass('has-error');
            return;
          }
        }
      });

      if (!hasInvalidFields) {
        var row_content = '';
        // set objects values and generate row content
        $.each(fields, function(index, value) {
          var cssClass = '';
          if (value.hasClass('radio_buttons')) {
            element = $(value.selector + ":checked");
            local_object[index] = element.val();
            $('input[name="' + value.attr('name') + '"]').prop("checked", false);
          } else {
            local_object[index] = value.val();
            value.val('');
          }

          if (value.hasClass('selectized')) {
            $(value).selectize()[0].selectize.setValue('');
          }

          if (value.data('class')) {
            cssClass = 'class="' + value.data('class') + '"'
          }

          row_content = row_content + "<td " + cssClass +">" + local_object[index] + "</td>";
        });

        var edit_delete_btn = '<span class="fa fa-pencil-square-o edit-object"></span><span class="fa fa-minus-square-o remove-object"></span>';
        row_content = row_content + "<td>" + edit_delete_btn + "</td>";

        if (button.data('object-id') !== undefined) {
          $(config.table_selector + ' *[data-object-id="' + button.data('object-id') + '"]').html(row_content);
        } else {
          object_storage.push(local_object);
          local_object.id = object_storage.length - 1;
          $(config.table_selector + ' tbody').append("<tr data-object-id='" + local_object.id + "'>" + row_content + "</tr>");
        }

        // show table if at least one row is present
        if ($(config.table_selector + ' tbody tr').length > 0) {
          $(config.table_selector).show();
        } else {
          $(config.table_selector).hide();
        }

        var remove_selector = config.table_selector + ' tr[data-object-id=' + local_object.id + '] .remove-object';
        var edit_selector = config.table_selector + ' tr[data-object-id=' + local_object.id + '] .edit-object';

        addRemoveHandler(remove_selector, local_object.id, object_storage, config, button);
        addEditHandler(edit_selector, local_object.id, object_storage, button, config);

        button.removeData('object-id');
      }
    };

    function applyFormSubmitHandler() {
      $('.apply-form').on('submit', function(event) {
        var form = $('#apply-form');
        form_config = [
          // { name: 'dependants', storage: dependants },
          { name: 'academic_qualifications', storage: academic_qualifications },
          { name: 'trainings', storage: trainings },
          { name: 'associations', storage: associations },
          { name: 'experience', storage: experience },
          { name: 'references', storage: references }
        ];

        $.each(form_config, function(i, config) {
          $.each(config.storage, function(index, local_object) {
            $.each(local_object, function(key, value) {
              form.append('<input type="hidden" name="forms_application_form[' + config.name + '][][' + key + ']" value="' + value + '" />');
            });
          });
        });
        ga('send', 'event', 'ApplyForm', 'submit');
      });
    }

    function applyBtnHandler() {
      $(settings.applyBtn).on('click', function(event, data) {
        var container = $(settings.container);
        var isVisible = container.is(':visible');
         $("html, body").animate({
              scrollTop: container.offset().top + 100
          }, {
              duration: 200,
              easing: settings.animationEasing
          });
        container.slideToggle({duration: 500, easing: 'easeInOutExpo' });
        initialize_apply_form();

        ga('send', 'event', 'Careers Apply Form', (isVisible ? 'close' : 'open'));
        return false;
      });
    };

    function addRowBtnHandlers() {
      // $(settings.saveDependantBtn).on('click', function(event) {
      //   var object_storage = dependants;
      //   var config = addRowConfig.dependants;
      //   var $button = $(this);
      //   saveRow(config, $button, object_storage);
      //   return false;
      // });

      $(settings.saveAcademicQualificationBtn).on('click', function(event) {
        var object_storage = academic_qualifications;
        var config = addRowConfig.academicQualifications;
        var $button = $(this);
        saveRow(config, $button, object_storage);
        return false;
      });

      $(settings.saveTrainingsBtn).on('click', function(event) {
        var object_storage = trainings;
        var config = addRowConfig.trainings;
        var $button = $(this);
        saveRow(config, $button, object_storage);
        return false;
      });

      $(settings.saveAssociationsBtn).on('click', function(event) {
        var object_storage = associations;
        var config = addRowConfig.associations;
        var $button = $(this);
        saveRow(config, $button, object_storage);
        return false;
      });

      $(settings.saveExperienceBtn).on('click', function(event) {
        var object_storage = experience;
        var config = addRowConfig.experience;
        var $button = $(this);
        saveRow(config, $button, object_storage);
        return false;
      });

      $(settings.saveReferencesBtn).on('click', function(event) {
        var object_storage = references;
        var config = addRowConfig.references;
        var $button = $(this);
        saveRow(config, $button, object_storage);
        return false;
      });
    };

    var regionSelectResultHandler = function() {
      $(settings.regionSelect).on('ajax:success', function(event) {
        const data = event.detail[2].responseText;

        $(settings.regionSelectResultsContainer).html(data);
        selectize_all_selects();
      })
    }

    function removeFileHandler(uploadField, target_selector) {
      $(target_selector + ' .remove-upload-file').on('click', function(event) {
        $(uploadField).val("");
        $(target_selector).html("");
        event.preventDefault();
      });
    }

    var addEventHandler = function() {
      applyBtnHandler();
      regionSelectResultHandler();
      addRowBtnHandlers();
      applyFormSubmitHandler();
      removeFileHandler();
    }

    addEventHandler();
    return this;
  };

}(jQuery));
